import { createSelector } from 'reselect';


export const getRequestDocuments = createSelector( 
    state => state?.orderPlaced?.customerRequest?.requestDocuments,
    requestDocuments => requestDocuments
);


